export default [
  {
    path: "/360",
    name: "360",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/wb",
    name: "wb",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/sougou",
    name: "sougou",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/3601",
    name: "3601",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/2345",
    name: "2345",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/cnxh",
    name: "cnxh",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/tieba",
    name: "tieba",
    component: () => import("@/views/tieba/index.vue"),
  },
  {
    path: "/xunyou",
    name: "xunyou",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/07073",
    name: "07073",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/yueke",
    name: "yueke",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/yx360",
    name: "yx360",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/yx3602",
    name: "yx3602",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/sw360",
    name: "sw360",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/xunlan",
    name: "xunlan",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/yueke1",
    name: "yueke1",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/fs3603",
    name: "fs3603",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/baidu6",
    name: "baidu6",
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/baidu7",
    name: "baidu7",
    component: () => import("@/views/basePc/index.vue"),
  },
];
